import { useEffect, useState } from "react";
import { RenderName, TableHeader, TableRow } from "../../components";
import { rejectedHeaders } from "./OfficeScreenData";
import { OfficeState } from "../../models/office.model";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { searchPendingOffice, sortObj } from "../../redux/slices/OfficeSlice";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const Rejected = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [extraClasses] = useState<string[]>(rejectedHeaders.map(head => head.extraClasses));
  const { pendingOffices, sort } = useSelector((state: RootState) => state.office);

  // const onPageChange = (e: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
  //   updateTable({ sortedBy: sort.sortedBy, pageNumber: newPage, rowsPerPage: sort.rowsPerPage }, searchTerm);
  // };

  // const onRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  //   updateTable({ sortedBy: sort.sortedBy, pageNumber: 0, rowsPerPage: parseInt(event.target.value, 10) }, searchTerm);
  // };

  const updateTable = (sortObj?: sortObj, searchText?: string) => {
    const pageNumToBeCalled = sortObj?.pageNumber ?? sort.pageNumber;
    const sortBy = sortObj?.sortedBy ?? "rejectedDate,desc";
    const searchT = searchText ?? "";
    dispatch(
      searchPendingOffice({
        searchTerm: searchT,
        page: pageNumToBeCalled,
        size: 100,
        sortType: sortBy,
        officeStates: [OfficeState.Rejected],
      })
    );
  };

  useEffect(() => {
    updateTable();
  }, []);

  return (
    <div>
      <div className="flex justify-between items-center border-b border-docsigna-blue-light">
        {rejectedHeaders.map((head, index) => (
          <TableHeader
            title={head.title}
            index={index}
            key={index}
            sortIcon={null}
            handleSort={() => null}
            extraClassesHeader={head.extraClasses}
            isClickable={head.isClickable}
          />
        ))}
      </div>
      {pendingOffices.map((item, index) => {
        const rowData = {
          date: item.rejectedDate ? moment(item.rejectedDate).format("ll") : "-",
          office: <RenderName title={item.name} subTitle="" />,
          contact: item.contactName,
          email: <p className="text-sm ">{item.contactEmail}</p>,
        };
        return (
          <TableRow
            data={Object.values(rowData)}
            key={index}
            id={""}
            tooltipVisible={false}
            handleOpenTooltip={() => null}
            handleCloseTooltip={() => null}
            tooltipOptions={[]}
            extraClassesRow={extraClasses}
            onRowClick={() => {
              navigate("/offices/" + item.officeId + "/requests");
            }}
            rejectedReason={
              item.rejectedReason ? (
                <p>
                  <b>Reason:</b> {item.rejectedReason}
                </p>
              ) : undefined
            }
          />
        );
      })}
    </div>
  );
};

export default Rejected;
